// COURSE TAB ENUMS
export const COURSE_TABS_ENUMS = {
  OVERVIEW: "overview",
  CONTENT: "content",
  LIVECLASS: "liveClasses",
  ANNOUNCEMENTS: "announcements",
  TRIAL_CONTENT: "trialContent"
};

// DEEPLINK ACTION ENUMS
export const COMMON_DEEPLINK_ACTIONS = {
  CHAT_DETAILS_CREATE_V2: `CHAT_DETAILS_CREATE_V2`,
  ACTION_WEB_BACK_EVENT_ADDED: `ACTION_WEB_BACK_EVENT_ADDED`,
  ACTION_GET_REFRESH_TOKEN: `ACTION_GET_REFRESH_TOKEN`,
  OPEN_WEBVIEW: `OPEN_WEBVIEW`,
  UTIL_WEBVIEW: `UTIL_WEBVIEW`,
  OPEN_GO_LIVE: `OPEN_GO_LIVE`,
  UTIL_BROWSER: `UTIL_BROWSER`,
  UTIL_HIT_HAPTIC_FEEDBACK: `UTIL_HIT_HAPTIC_FEEDBACK`,
  BUY_NOW_CLICKED: `BUY_NOW_CLICKED`,
};

export const TAZAYPAY_PAYMENT_STATUS = {
  SUCCESS: "success",
  FAILURE: "failure",
  PENDING: "pending",
};

export const USER_AGENT_STRING = {
  ANDROID: "Mobile-Android",
  IOS: "Mobile - iOS",
  // IOS: "Mobile-Android", // testing for google payments
};

export const GOOGLE_CHROME_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_IN&gl=US";
export const ANDROID_SYSTEM_WEBVIEW_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.google.android.webview&hl=en_IN&gl=US";

  export const cdnBaseUrl = "cdn"